import { formatISO } from "date-fns";

export function formatKey(date: Date): string {
  return formatISO(date);
}
